export default {
  title: "Issue Designation",
  title_reference_placeholder: "__-_",
  subtitle: "<span class='text-info text-bold'>Raise issue</span> {designation}",
  entity_ref_label: "Existing Issues",
  issue: "Issue",
  issue_more_info: "Provide more information about the issue",
  work_domain_label: "Work Domain",
  select_priority_label: "Select a Priority",
  issue_description_label: "Issue description",
  correction_info: "Correction Information",
  corrective_action: "Corrective Action",
  user_error_creating_issue:
    "Data for creating an issue is insufficient. Make sure, you filled all required fields.",
  work_related_issue_message: "The Issue will be raised once the Work is submitted.",
}
